<div class="card p-d-flex p-jc-center">
  <p-chart #chart type="line" [data]="yoyData" [options]="chartOptions"
           [height]="height" [width]="width"></p-chart>
</div>

<!-- Loading Spinner -->
<img class="progress-spinner rotate" *ngIf="loading" src="assets/loading.png" alt="loading...">
